export const FETCH_SINGLE_USER_INFO = ()=> "api/user/get-single-user";